import React from "react";
import PayoutsTable from "../components-bootstrap/PayoutsTable";
import {
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
  formattedLongDate2,
} from "../common-data/Converts";
import PartialDetailsMobile from "../incentive-system/incentive-calculations/PartialDetailsMobile";

const PartialDetails = ({ tbData, isDF }) => {
  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {isDF
              ? row?.date_added
                ? formattedLongDate2(row.date_added)
                : "-"
              : row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0)}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}>
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div className="fullWidthFlexCenter separatedTable hideMobile">
        <PayoutsTable dataValues={tbData} columnsValues={pmInfoColumns} />
      </div>

      <div className="lead-logs-card-container only-mobile">
        <PartialDetailsMobile tableData={tbData} />
      </div>
    </>
  );
};

export default PartialDetails;
